import React from 'react'
import { withRouter } from 'react-router-dom'
import ConfirmationPage from '~/app/components/ConfirmationPage'
import { connect } from 'react-redux'
import { getProcessInstanceState } from '~/store/processinstance'
import { ThemeProvider } from 'styled-components'
import { getReturnOfExpression } from 'utility-types'
import CornerImages from '~/app/components/CornerImages'
import GlobalStyle from '~/app/styles/base'

const mapStateToProps = state => {
  return {
    processinstance: getProcessInstanceState(state),
  }
}
const mapDispatchToProps = {}

const stateProps = getReturnOfExpression(mapStateToProps)

type LocalCompProps = {}

type CompProps = typeof stateProps & typeof mapDispatchToProps & LocalCompProps

type State = {}

class ConfirmationCTR extends React.Component<CompProps, State> {
  render() {
    return (
      <ThemeProvider theme={this.props.processinstance.registrationEntity}>
        <div style={{ overflow: 'hidden' }}>
          <GlobalStyle />
          <CornerImages showBottomImages={true} images={this.props.processinstance.registrationEntity.cornerImages} />
          <ConfirmationPage
            entityName={this.props.processinstance.registrationEntity.entityName}
            eventText={this.props.processinstance.registrationEntity.eventText}
            isUnverified={this.props.processinstance.registrationEntity.sourceDeviceTokenUnverifiedProcessing}
          />
        </div>
      </ThemeProvider>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConfirmationCTR)
)
